import util from './util';
var _isEmpty = util.isEmpty;
var _groupMsgType = '1005';
var _shopModeUserSource = '9999';
// 撤回消息msg_status
var _isGroupSource = function (source) {
    return !_isEmpty(source) && Number(source) > 10000
}
var _isShopModeUserSource = function (source) {
    return !_isEmpty(source) && Number(source) == _shopModeUserSource;
}

var _isGroupUser = function (obj) {
    var isGroup = false;
    if (_isEmpty(obj)) {
        isGroup = false;
    } else if (!_isEmpty(obj.is_group) && obj.is_group) {
        // user判断
        isGroup = true;
    } else if (!_isEmpty(obj.sender_source) && !_isEmpty(obj.to_source) && !_isEmpty(obj.msg_type)) {
        // msg判断
        var isGruopSource = _isGroupSource(obj.sender_source) || _isGroupSource(obj.to_source);
        var msgType = obj.msg_type;
        isGroup = msgType + '' === _groupMsgType && isGruopSource;
    } else if (!_isEmpty(obj.user_source)) {
        // contact判断
        isGroup = _isGroupSource(obj.user_source);
    }
    return isGroup;
}

var _isShopModeUser = function (obj, me) {
    var isShopModeUser = false;
    if (_isEmpty(obj)) {
        isShopModeUser = false;
    } else if (!_isEmpty(obj.is_shop_mode) && obj.is_shop_mode) {
        // user判断
        isShopModeUser = true;
    } else if (!_isEmpty(obj.sender_source) && !_isEmpty(obj.to_source)) {
        // msg判断
        var isShopModeUserSource = _isShopModeUserSource(obj.sender_source) || _isShopModeUserSource(obj.to_source);
        var sendKey = obj.sender_id + '@' + obj.sender_source;
        var toKey = obj.to_id + '@' + obj.to_source;
        var currentuser = me;
        var meKey = currentuser.user_id + '@' + currentuser.user_source;
        isShopModeUser = isShopModeUserSource && sendKey != meKey && toKey != meKey;
    } else if (!_isEmpty(obj.user_source)) {
        // contact判断
        isShopModeUser = _isShopModeUserSource(obj.user_source);
    }
    return isShopModeUser;
}

export default {
    isGroupSource: _isGroupSource,
    isGroupUser: _isGroupUser,
    isShopModeUser: _isShopModeUser
}
